import { render } from "./CompetenceTetris.vue?vue&type=template&id=1d11c69c&scoped=true"
import script from "./CompetenceTetris.vue?vue&type=script&lang=js"
export * from "./CompetenceTetris.vue?vue&type=script&lang=js"

import "./CompetenceTetris.vue?vue&type=style&index=0&id=1d11c69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d11c69c"]])

export default __exports__